import { gemSeismicColors } from "../../util/colors";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";
import { HazardIdEnum, LocationRiskAssessment, PolicyDetails } from "../hazardIdEnum";

export const getIcelandHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.SeismicRiskGemIsl,
    name: "Seismic Risk Gem Iceland",
    // permissions: ["CYS_RISK_SEISMIC_GEM_ISL"],
    permissions: [PermissionIdEnum.SeismicRiskGemIsl],
    colorRange: gemSeismicColors,
    description: "Seismic Risk Gem Iceland",
    label: "Seismic Risk GEM (ISL)",
    pages: [PolicyDetails, LocationRiskAssessment],
  },
];
